module.exports = __webpack_public_path__ + "img/cpbg.7d464aa7.png";